import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import remove from "@beeldit/core/services/remove";
import { useContext } from "react";
import { EventRulePriceContext } from "../contexts/EventRulePriceContext";

function useRemove() {
  const {elementIdToDelete, setShowDeleteConfirmationModal} = useContext(EventRulePriceContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    remove('event_rule_prices', elementIdToDelete)
      .then((response: any) => {
        setShowDeleteConfirmationModal(false);
        onSuccess();
      }).catch((error: any) => {
        errorHandler(error)
    })
  }
}

export default useRemove;